import { render, staticRenderFns } from "./multi_person_deduction.vue?vue&type=template&id=0f1faab0"
import script from "./multi_person_deduction.vue?vue&type=script&lang=js"
export * from "./multi_person_deduction.vue?vue&type=script&lang=js"
import style0 from "./multi_person_deduction.vue?vue&type=style&index=0&id=0f1faab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports